const ROOM_ID = /^[A-Za-z0-9]{6,32}$/;

/**
 * The invite token lives in the URL fragment: fragments are never sent to the
 * server in HTTP requests nor leaked through the Referer header.
 */
export function buildInviteUrl(
  roomId: string,
  inviteToken: string,
  origin = window.location.origin,
): string {
  return `${origin}/r/${encodeURIComponent(roomId)}#invite=${encodeURIComponent(inviteToken)}`;
}

export function readInviteFromHash(hash: string): string | undefined {
  const value = new URLSearchParams(hash.replace(/^#/, '')).get('invite');
  return value && value.length <= 128 ? value : undefined;
}

/** Accepts a full invite link or a bare room code. */
export function parseInvite(input: string): { roomId: string; inviteToken?: string } | null {
  const trimmed = input.trim();
  if (ROOM_ID.test(trimmed)) return { roomId: trimmed };
  try {
    const url = new URL(trimmed);
    const match = /^\/r\/([A-Za-z0-9]{6,32})\/?$/.exec(url.pathname);
    if (!match?.[1]) return null;
    const inviteToken = readInviteFromHash(url.hash);
    return inviteToken ? { roomId: match[1], inviteToken } : { roomId: match[1] };
  } catch {
    return null;
  }
}

export function roomPath(roomId: string, inviteToken?: string): string {
  return `/r/${encodeURIComponent(roomId)}${inviteToken ? `#invite=${encodeURIComponent(inviteToken)}` : ''}`;
}
